import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAdnocLogoFull = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 76 114",
	style: { enableBackground: "new 0 0 76 114" },
	xmlSpace: "preserve",
	...props,
	children: [/* @__PURE__ */ _jsx("style", {
		type: "text/css",
		children: "\n	.st0{fill:#FFFFFF;}\n	.st1{fill:#0047BA;}\n	.st2{fill:none;stroke:#E4087E;stroke-width:0.18;stroke-miterlimit:10;}\n"
	}), /* @__PURE__ */ _jsxs("g", { children: [
		/* @__PURE__ */ _jsx("rect", {
			y: .2,
			className: "st0",
			width: 75.9,
			height: 113.8
		}),
		/* @__PURE__ */ _jsxs("g", { children: [
			/* @__PURE__ */ _jsx("path", {
				className: "st1",
				d: "M58.6,58.1c-0.9,3.9-2.8,7.2-5.5,9.9h14.7c2.8-15.3-7.3-31.6-23.7-35.1C47.4,33.8,61.9,40.6,58.6,58.1"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "st1",
				d: "M7.6,7.8V68l6.4,0c3.9,0,4.8,0.1,6.9-0.3c9.2-1.3,17.6-8.8,18.5-15.4c1.4-7.8-2.9-14.7-11.1-16.4    c-0.1,0-0.3-0.1-0.5-0.1c-0.3,0-4.3,0-7.3-0.8c0,0-1.8,1.4-1.1,4c0,0-4.1-4.3-1.5-10c0,0,1.3-2.7,5.5-5.5c0,0,0.1-0.1,0.1-0.1    c1.1-1.4,3.9-3.8,7.9-5.6c2-0.9,5.5-2.2,9.4-2.6c17.8-1.7,27.4,12,27.4,12V7.8H7.6z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "st1",
				d: "M51.5,22.4c-8.5-1.1-15.7,1.1-21.4,5c0,0,1.7-1,4.2-1.9c0.4,1.6,1.8,3,3.6,3.4c2.5,0.5,4.9-0.9,5.4-3.3    c0.1-0.6,0.1-1.3-0.1-1.9c16.3-0.5,25,12,25,12l0-5.4C65.8,27.9,59.1,23.2,51.5,22.4"
			})
		] }),
		/* @__PURE__ */ _jsxs("g", { children: [
			/* @__PURE__ */ _jsx("path", {
				className: "st1",
				d: "M12.1,94.1h2.4l4.5,12h-2.7l-1-2.8h-4.2l-1,2.8H7.6L12.1,94.1z M14.7,101.3L13.2,97l-1.4,4.3H14.7z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "st1",
				d: "M20.5,94.1h4.5c1.8,0,3.3,0.5,4.3,1.5c1,1,1.5,2.5,1.5,4.4c0,1-0.1,1.9-0.4,2.6c-0.3,0.8-0.7,1.4-1.2,1.9    c-0.5,0.5-1.2,0.9-2,1.2c-0.8,0.3-1.6,0.4-2.6,0.4h-4.1V94.1z M24.6,104c0.6,0,1.2-0.1,1.7-0.3c0.5-0.2,0.8-0.5,1.1-0.8    c0.3-0.3,0.5-0.8,0.6-1.2c0.1-0.5,0.2-1,0.2-1.6c0-0.6-0.1-1.1-0.2-1.6c-0.1-0.5-0.3-0.9-0.6-1.2c-0.3-0.3-0.6-0.6-1-0.8    c-0.4-0.2-0.9-0.3-1.5-0.3h-2v7.7H24.6z"
			}),
			/* @__PURE__ */ _jsx("polygon", {
				className: "st1",
				points: "32.8,94.1 35,94.1 39.9,102 39.9,94.1 42.4,94.1 42.4,106.1 40.1,106.1 35.2,98.3 35.2,106.1     32.8,106.1   "
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "st1",
				d: "M50.2,106.4c-0.9,0-1.7-0.1-2.4-0.4c-0.7-0.3-1.3-0.7-1.8-1.3c-0.5-0.5-0.9-1.2-1.1-2    c-0.3-0.8-0.4-1.6-0.4-2.6c0-1,0.1-1.8,0.4-2.6c0.3-0.8,0.6-1.4,1.1-2c0.5-0.5,1.1-1,1.8-1.3c0.7-0.3,1.5-0.4,2.4-0.4    c0.9,0,1.7,0.1,2.4,0.4c0.7,0.3,1.3,0.7,1.8,1.3c0.5,0.5,0.9,1.2,1.1,2c0.3,0.8,0.4,1.6,0.4,2.6c0,1-0.1,1.8-0.4,2.6    c-0.3,0.8-0.6,1.4-1.1,2c-0.5,0.5-1.1,1-1.8,1.3C51.9,106.3,51.1,106.4,50.2,106.4 M50.2,104.3c1.1,0,1.8-0.4,2.4-1.1    c0.5-0.7,0.8-1.7,0.8-3.1c0-1.3-0.3-2.3-0.8-3.1C52,96.3,51.2,96,50.2,96c-1.1,0-1.8,0.4-2.4,1.1c-0.5,0.7-0.8,1.7-0.8,3.1    c0,1.3,0.3,2.4,0.8,3.1C48.3,103.9,49.1,104.3,50.2,104.3"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "st1",
				d: "M68.1,102c-0.1,0.6-0.2,1.2-0.4,1.8c-0.2,0.5-0.6,1-1,1.4c-0.4,0.4-0.9,0.7-1.5,0.9c-0.6,0.2-1.3,0.3-2.1,0.3    c-0.9,0-1.7-0.2-2.4-0.5c-0.7-0.3-1.3-0.7-1.7-1.3c-0.5-0.5-0.8-1.2-1-2c-0.2-0.8-0.4-1.6-0.4-2.6c0-1,0.1-1.8,0.4-2.6    c0.3-0.8,0.6-1.4,1.1-2c0.5-0.5,1.1-1,1.7-1.3c0.7-0.3,1.5-0.4,2.3-0.4c0.8,0,1.4,0.1,2,0.3c0.6,0.2,1,0.5,1.4,0.8    c0.4,0.4,0.7,0.8,0.9,1.3c0.2,0.5,0.4,1.1,0.5,1.7l-2.5,0.3c-0.1-0.7-0.4-1.3-0.7-1.7C64.3,96.2,63.8,96,63,96    c-1,0-1.7,0.4-2.2,1.1c-0.5,0.7-0.7,1.7-0.7,3.1c0,1.3,0.3,2.4,0.8,3.1c0.5,0.7,1.2,1.1,2.1,1.1c0.8,0,1.3-0.2,1.7-0.6    c0.4-0.4,0.6-1,0.7-1.7H68.1z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "st1",
				d: "M20.5,86.5V75.8H23v12.8H12.5c-1.7,0-2.9-0.4-3.7-1.1c-0.8-0.7-1.2-1.8-1.2-3.3c0-0.8,0.2-1.5,0.5-2.2    C8.5,81.5,9,81,9.6,80.7c0.7-0.4,1.4-0.6,2.3-0.6l0.3,2.1c-0.8,0.1-1.4,0.3-1.7,0.6c-0.3,0.3-0.5,0.8-0.5,1.5    c0,0.8,0.2,1.3,0.6,1.7c0.4,0.3,1,0.5,1.8,0.5H20.5z M18.1,81v0.8h-3.2V81h0.4v-0.5c0-0.4,0.1-0.8,0.4-1c0.2-0.2,0.6-0.3,1-0.3    c0.4,0,0.8,0.1,1,0.3c0.2,0.2,0.3,0.5,0.4,0.9l-0.8,0.1c0-0.2-0.1-0.3-0.1-0.4c-0.1-0.1-0.2-0.1-0.4-0.1c-0.4,0-0.6,0.2-0.6,0.6    V81H18.1z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "st1",
				d: "M46.8,79.7v6.7H33.1v-2.6c0-1.4-0.3-2.4-1-3.1c-0.7-0.7-1.7-1-3-1c-1.3,0-2.3,0.4-3,1.1    c-0.7,0.7-1.1,1.7-1.1,3c0,1.5,0.5,2.8,1.4,3.6c0.9,0.8,2.3,1.2,4,1.2h0.3v0.3c0,1-0.1,1.5-0.4,1.8l1.2,1.9    c0.2-0.1,0.4-0.3,0.6-0.4c0.7-0.7,1-2.2,1-3.6h16.2v-8.9H46.8z M30.7,86.5h-0.8c-1.7,0-2.5-1-2.5-2.6c0-0.7,0.1-1.2,0.4-1.5    c0.3-0.4,0.7-0.5,1.3-0.5c0.4,0,0.7,0.1,1,0.2c0.2,0.1,0.4,0.4,0.5,0.7c0.1,0.4,0.2,1.1,0.2,1.8V86.5z"
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 46.8,
				y: 76.1,
				className: "st1",
				width: 2.4,
				height: 2.4
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "st1",
				d: "M60.7,86.5v-1.3c0-1.1-0.2-1.9-0.6-2.4c-0.4-0.5-1-0.8-1.9-0.8c-0.6,0-1.2,0.1-1.8,0.3l-0.6-2.1    c0.8-0.3,1.7-0.4,2.6-0.4c1.5,0,2.7,0.4,3.5,1.3c0.8,0.9,1.2,2.2,1.2,3.9v3.7H51.1v-2.2H60.7z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "st1",
				d: "M68.1,75.2v0.8h-3.2v-0.8h0.4v-0.5c0-0.4,0.1-0.8,0.4-1c0.2-0.2,0.6-0.4,1-0.4c0.4,0,0.8,0.1,1,0.3    c0.2,0.2,0.3,0.5,0.4,0.9l-0.8,0.1c0-0.2-0.1-0.3-0.1-0.4c-0.1-0.1-0.2-0.1-0.4-0.1c-0.4,0-0.6,0.2-0.6,0.6v0.5H68.1z"
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 65.2,
				y: 77,
				className: "st1",
				width: 2.4,
				height: 11.6
			})
		] }),
		/* @__PURE__ */ _jsx("path", {
			className: "st2",
			d: "M20.5,68.3"
		})
	] })]
});
export default SvgAdnocLogoFull;
